export const query = state => {
  return {
    vendor: state.vendor,
    description: state.description,
    amount: state.amount ? parseFloat(state.amount) : undefined
  }
}

export const loaded = (state) => {
  return state.loaded
}
